export const EffectiveEntryStatus = {
  // AFTER is a client-only status: this is used on any stack entry after current.
  After: 'AFTER',
  // BlockedDownstack is a client-only status: an entry that would be Ready but
  // is stacked above a not-ready/draft/closed entry, so it can't merge yet.
  BlockedDownstack: 'BLOCKED_DOWNSTACK',
  Closed: 'CLOSED',
  Draft: 'DRAFT',
  Loading: 'LOADING',
  Merged: 'MERGED',
  Merging: 'MERGING',
  NotReady: 'NOT_READY',
  Queued: 'QUEUED',
  Ready: 'READY',
} as const

export type EffectiveEntryStatus = (typeof EffectiveEntryStatus)[keyof typeof EffectiveEntryStatus]
